import React from "react"
import Typography from "aldoo-ra/Typography"
import Button from "aldoo-ra/Button"
import { EyeIcon } from "@heroicons/react/24/outline"
import { url } from "aldoo-ra/CMS/url"
import TextBundle from "aldoo-ra/CMS/text-bundle"

const LicenseCard = ({ 
  license, 
  onLicenseSelect,
  getStatusConfig,
  calculateUsagePercentage 
}) => {
  const texts = TextBundle({ id: "licenses_main" })
  const productName = license.productName || license.productId || texts?.unknown_product || "Unknown Product"
  const statusConfig = getStatusConfig(license.status)
  const usagePercentage = calculateUsagePercentage(license.usedSeats || 0, license.seats)

  return (
    <div 
      className="account-card shadow-custom_card cursor-pointer"
      onClick={() => onLicenseSelect(license._id)}
    >
      {/* Product Title */}
      <div className="flex items-center space-x-3 mb-5">
        <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-gray_3/30 rounded">
          {license.product?.thumbnail ? (
            <img
              src={url(license.product.thumbnail)}
              alt={productName}
              className="w-8 h-8 object-contain rounded"
            />
          ) : (
            <Typography 
              variant="body_24" 
              className="text-gray_1 font-medium my-0"
            >
              {productName.charAt(0).toUpperCase()}
            </Typography>
          )}
        </div>
        
        <div className="flex-1">
          <Typography 
            variant="body_16" 
            className="font-medium text-text my-0"
          >
            {productName}
          </Typography>
        </div>
      </div>

      {/* Card Content - Three columns */}
      <div className="flex flex-col w-full border-b pb-4">
        {/* Seats */}
        <div className="mb-4">
          <Typography 
            variant="info_12" 
            className="text-gray_2 uppercase tracking-wide mt-0 mb-0.5"
          >
            {texts?.seats_column || "Seats"}
          </Typography>

          <Typography 
            variant="body_14" 
            className="font-medium leading-tight my-0"
          >
            {license.usedSeats || 0} / {license.seats}
          </Typography>

          <div className="flex items-center space-x-2 mt-0.5">
            <div className="w-16 bg-gray_3 rounded-full h-1">
              <div 
                className="bg-primary h-1 rounded-full transition-all duration-300"
                style={{ width: `${usagePercentage}%` }}
              />
            </div>

            <Typography 
              variant="info_16" 
              className="text-gray_2 leading-none my-0"
            >
              {usagePercentage}%
            </Typography>
          </div>
        </div>

        {/* Status */}
        <div>
          <Typography 
            variant="info_12" 
            className="text-gray_2 uppercase tracking-wide mt-0 mb-1"
          >
            {texts?.status_column || "Status"}
          </Typography>

          <span className={`px-3 py-1 rounded-full text-sm font-medium ${statusConfig.color}`}>
            {statusConfig.label}
          </span>
        </div>
      </div>

      {/* Details Button */}
      <div className="flex justify-end ml-auto mt-6">
        <Button
          variant="secondary_s"
          onClick={(e) => {
            e.stopPropagation()
            onLicenseSelect(license._id)
          }}
          className="flex items-center gap-2"
        >
          <EyeIcon className="w-4 h-4" />
          {texts?.details_button || "Details"}
        </Button>
      </div>
    </div>
  )
}

export default LicenseCard